module.exports = __webpack_public_path__ + "media/images/person-87ea04bb1124b3454b4772ddfeceabb1.svg";